export default {
  title: 'Restricted access',
  message: 'We are sorry, you do not have access to this page.',
  technicalErrorButton: 'Back to home page',
};
